import { trackEvent } from "../services/analyticsService";
import { isAccessLimitedByParentalLevel } from "../services/parentalControlService";
import { routes } from "../routes/index";

// TODO Describe that this needs to have history object in this to work
/**
 * This service has the responsibility to act to deep link navigation requests. For now it's just a navigator to the
 * page the deep link action requested but in the future it will be more complex providing options like playing content
 * directly.
 * @param {Object} deepLinkAction Object containing information about the action to be performed in response to the
 * requested deep linking action. Properties this object can have:
 * - category: series|movies
 * - titleId: number
 * - seasonNumber: number,
 * - episodeNumber: number,
 * - play: boolean
 * - sectionId\": ""
 * - lang: en|ar|fr
 */
export function executeDeepLinkAction(deepLinkAction) {
  trackEvent("eden", "eden wakeup", deepLinkAction.titleId);
  const section = getSectionFromDeepLinkObject(deepLinkAction);
  const kidsPath = isAccessLimitedByParentalLevel() ? routes.kids : "";
  this.history.push(`${kidsPath}/${section}/${deepLinkAction.titleId}`, {
    deepLinkReferrer: true
  });
}

function getSectionFromDeepLinkObject(link) {
  const sections = {
    series: "series",
    movie: "movies"
  };
  return sections[link.category];
}
